import { AssistantNotes, type EntityRef } from '@speles7172/assistant-console';
import '@speles7172/assistant-console/styles.css';
import { assistantTransport } from '../../api/assistant';
import { useAssistantNavigation } from './useAssistantNavigation';

/**
 * A record's assistant notes — an event's, a venue's: written under it, or
 * linked to it by the assistant — with the composer filing new ones under it.
 * Without a `scope`, the producer's own notebook, whose composer asks what a
 * note is about and lets the assistant work it out.
 */
export function RecordNotes({ scope }: { scope?: EntityRef | null }) {
  const { onOpen, onActionDone, language } = useAssistantNavigation();
  return (
    <div className="peles-controls">
      <AssistantNotes
        transport={assistantTransport}
        {...(scope === undefined ? {} : { scope })}
        onOpen={onOpen}
        onActionDone={onActionDone}
        language={language}
        theme="light"
      />
    </div>
  );
}
